export default {
    SET_SUGGESTEDCOURSES(state, value) {
      state.suggestedCourses = value;
    },
  };